module.exports = __webpack_public_path__ + "img/img_road-in-wichita.d9335820.png";